import { NUMERIC_COLUMN_TYPES } from '../constants';

/** True when a dataset definition item holds a number (per item.type). */
export const isNumericItemType = (type?: string): boolean =>
  NUMERIC_COLUMN_TYPES.includes((type ?? '').toLowerCase());
